export default __webpack_public_path__ + "static/media/Tria Logo_Primary_With Tag.07b4eeb5.png";